import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d847467"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["lux-avatar", { 'lux-avatar--thinking': _ctx.thinking }]),
    style: _normalizeStyle(_ctx.sizeStyle)
  }, [
    _createElementVNode("img", {
      src: _ctx.src,
      alt: "Lux"
    }, null, 8, _hoisted_1)
  ], 6))
}